import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DisplayMultipleNamesModule } from '../../../subject/pipes/display-multiple-names.module'
import { DisplayMultipleNamesShortModule } from '../../../subject/pipes/display-multiple-names-short.module'
import { DisplayCountOwnersModule } from '../../../subject/pipes/display-count-owners.module'
import { SubjectUserBadgeModule } from '../../../subject/components/subject-user-badge/subject-user-badge.module'
import { ContractListItemOwnersComponent } from './contract-list-item-owners.component'

@NgModule({
    imports: [
        CommonModule,
        DisplayMultipleNamesModule,
        DisplayMultipleNamesShortModule,
        DisplayCountOwnersModule,
        SubjectUserBadgeModule,
    ],
    declarations: [ContractListItemOwnersComponent],
    exports: [ContractListItemOwnersComponent],
})
export class ContractListItemOwnersModule {
}